import { HttpErrorResponse } from '@angular/common/http';
import { XVII18nService } from '@app/i18n/services';
import { IErrorOverride } from '@app/shared/types';
import { isEmpty } from 'lodash';
import { XVIConnectionError, XVIError } from '../../models';

export class HttpErrorHandler {
  public static composeError(
    httpError: HttpErrorResponse,
    options: {
      errorOverride?: IErrorOverride;
      i18nService: XVII18nService;
    },
  ): XVIError {
    const statusCode = httpError.status;

    const { errorOverride, i18nService } = options;

    if (statusCode === 0) {
      return new XVIConnectionError({
        errorMessage: errorOverride?.commonError,
        i18nService,
      });
    }

    if (!isEmpty(errorOverride?.apiError)) {
      return new XVIConnectionError({
        errorMessage: errorOverride?.apiError,
        i18nService,
      });
    }

    return httpError.error;
  }
}
